export default __webpack_public_path__ + "static/media/Ilus-Ahorra.7848baaa.svg";